import * as React from 'react';
import StoreHook from './hook';
import { FaCaretDown } from 'react-icons/fa'
import { IStoreResponse } from '../../interfaces/store';
import { Link } from 'react-router-dom';
import icon2 from '../../img/icon2.png';
import ConfigurationService from "../../services/configuration-service";
import { IBenefitResponse } from "../../interfaces/benefit";
import { idPlnMomentaMais, 
    idPresentationDAEM, 
    idPresentationEZONIA, 
    idPresentationRIPOSO,
    idCupomDAEM,
    idCupomEZONIA,
    idCupomRIPOSO } from "../../config"

interface IProps
{
    setStores: (stores: IStoreResponse[]) => void;
    setInfoMessage: (infoMessage: string) => void;
}

export default function StoreSearchPage(props: IProps)
{
    const [ stateId, setStateId ] = React.useState<number>(0);
    const [ cityId, setCityId ] = React.useState<number>(0);
    const [ neighborhoodName, setNeighborhoodName ] = React.useState<string>("");
    const [ loading, setLoading ] = React.useState(false);

    const [msgErroState, setMsgErroState] = React.useState<boolean>(false);
    const [msgErroCity, setMsgErroCity] = React.useState<boolean>(false);
    const [msgErroNeighborhoodName, setMsgErroNeighborhoodName] = React.useState<boolean>(false);

    const { states, getState,
            cities, getCities,
            neighborhoods, getNeighborhoods,
            loadingStates, loadingCities,
            loadingNeighborhoods, getStores } = StoreHook();
    
    React.useEffect(() => { getState(); }, []);
    React.useEffect(() => { getCities(stateId); }, [ stateId ]);
    React.useEffect(() => { getNeighborhoods(cityId, idPlnMomentaMais); }, [ cityId, idPlnMomentaMais ]);
    


    const idMap: { [key: string]: number } = {
        [idCupomDAEM]: idPresentationDAEM,
        [idCupomEZONIA]: idPresentationEZONIA,
        [idCupomRIPOSO]: idPresentationRIPOSO
    };



    const validaCampos = () => {
        if(stateId === 0) setMsgErroState(true)
        if(cityId === 0) setMsgErroCity(true)
        if(!neighborhoodName) setMsgErroNeighborhoodName(true)
    }

    return (
        <div className="header__form">
            <Link to="/" className="header__logo-1">
                <img src={icon2} alt="icon2" />
            </Link>
            <p className="p-text">
                Olá, seja muito bem-vindo ao serviço de busca de farmácias. Selecione abaixo os dados de sua localização para encontrarmos a farmácia mais próxima a você.
            </p>
            <form action="#">
                <span className='mensagem-erro' hidden={!msgErroState}>Campo Obrigatório</span>
                <div className="form-group">
                    <select  onChange={event => {
                        setStateId(parseInt(event.currentTarget.value))
                        setMsgErroState(false)
                    }}>
                        {
                            loadingStates ?
                                <option value="" disabled selected hidden>
                                    Carregando...
                                </option> :
                                <option value="" disabled selected hidden>
                                    Estado
                                </option>
                        }
                        {
                            states &&
                            states.map(state =>
                                <option key={state.id} value={state.id}>
                                    {state.name}
                                </option>)
                        }
                    </select>       
                    <span className="arrow-down"><FaCaretDown /></span>
                </div>       
                
                <span className='mensagem-erro' hidden={!msgErroCity}>Campo Obrigatório</span>
                <div className="form-group">
                    <select
                        disabled={!(stateId > 0)}
                        onChange={event => {
                            setCityId(parseInt(event.currentTarget.value))
                            setMsgErroCity(false)
                        }}
                    >
                        {
                            loadingCities ?
                                <option value="" disabled selected hidden>
                                    Carregando...
                                </option> :
                                <option value="" disabled selected hidden>
                                    Cidade
                                </option>
                        }
                        {
                            cities &&
                            cities.map(city =>
                                <option key={city.id} value={city.id}>
                                    {city.name}
                                </option>)
                        }
                    </select>
                    <span className="arrow-down"><FaCaretDown /></span>
                </div>
                <span className='mensagem-erro' hidden={!msgErroNeighborhoodName}>Campo Obrigatório</span>
                <div className="form-group">
                    <select
                        disabled={!(cityId > 0) || loadingCities}
                        onChange={event => {
                            setNeighborhoodName(event.currentTarget.value)
                            setMsgErroNeighborhoodName(false)
                        }}
                    >
                        {
                            loadingNeighborhoods ?
                                <option value="" disabled selected hidden>
                                    Carregando...
                                </option> :
                                <option value="" disabled selected hidden>
                                    Bairro
                                </option>
                        }
                        {
                            neighborhoods &&
                            neighborhoods.map(neighborhood =>
                                                <option key={neighborhood.name} value={neighborhood.name}>
                                                    {neighborhood.name}
                                                </option>)
                        }
                    </select>
                    <span className="arrow-down"><FaCaretDown /></span>
                </div>
                <button
                    
                    className={"btn-primary " + (loading || !neighborhoodName ? "btn-disabled" : "")}
                    disabled={loading}
                    onClick={async (e) =>
                    {
                        if(stateId === 0 ||  cityId === 0 || !neighborhoodName){
                            e.preventDefault()
                            validaCampos();
                        } else {
                            setLoading(true);
                        
                            const stores = await getStores(cityId, neighborhoodName, idPlnMomentaMais);
                            const message = (stores && stores.length > 0)
                                            ? 'Veja as farmácias próximas a você:'
                                            : 'Não existem farmácias credenciadas para a pesquisa usada. Certifique-se de ter selecionado o estado, cidade e bairro corretos.';
    
                            props.setInfoMessage(message);
                            props.setStores(stores);
                            setLoading(false);
                        }
                    }}
                >
                    { loading ? "Buscando..." : "Buscar" }
                </button>
            </form>
        </div>
    )
}
